/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { WeatherStationDataMonthStat } from '../../models/weather-station-data-month-stat';

export interface GetMonthNorms$Params {
   /**
    * Provider id (IBM,EPA5,etc)
    */
   providerId?: string;

   /**
    * Latitude
    */
   lat: number;

   /**
    * Longitude
    */
   lon: number;

   /**
    * Weather calculation mode (avg, near)
    */
   mode?: string;
}

export function getMonthNorms(
   http: HttpClient,
   rootUrl: string,
   params: GetMonthNorms$Params,
   context?: HttpContext
): Observable<StrictHttpResponse<Array<WeatherStationDataMonthStat>>> {
   const rb = new RequestBuilder(rootUrl, getMonthNorms.PATH, 'get');
   if (params) {
      rb.query('providerId', params.providerId, {});
      rb.query('lat', params.lat, {});
      rb.query('lon', params.lon, {});
      rb.query('mode', params.mode, {});
   }

   return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
         return r as StrictHttpResponse<Array<WeatherStationDataMonthStat>>;
      })
   );
}

getMonthNorms.PATH = '/api/weather/weather/monthNorms';
